<template>
    <div v-if="dossier" class="container">
        <h3 id="top-feuillet" >{{$t('Bareme.etape2.resultat.titre')}}</h3>
        <!--<section-info-bareme-ajuste :dossier="dossier"></section-info-bareme-ajuste>-->
        <section-donnees-formulaire :dossier="dossier"
                                    :col-left="hasRemarques ? 'col-md-7' : 'col-md-8'"
                                    :col-right="hasRemarques ? 'col-md-7 text-left' : 'col-md-4 text-left'"
                                    :col-width="hasRemarques ? 'col-md-12' : 'col-md-12'"
                                    table-class="table table-bordered table-striped">
        </section-donnees-formulaire>
        <section-resultat-bareme :dossier="dossier"></section-resultat-bareme>
        <section-info-bareme-ajuste :dossier="dossier"></section-info-bareme-ajuste>
        <section-info-bareme-h :dossier="dossier" v-if="this.dossier.isMessageBaremeH"></section-info-bareme-h>
        <section-buttons :on-submit="onSubmit" :on-generer-pdf="onGenererPdf"  :dossier="dossier"></section-buttons>
    </div>
</template>

<script>
import ImpotSourceRestApi from '@/services/ImpotSourceRestApi';
import ContribuableIsDto from '@/models/bareme/ContribuableIsDto';
import ProgressBarUtils from '@/utils/ProgressBarUtils';
import SectionInfoBaremeAjuste from '../sections/bareme/SectionInfoBaremeAjuste.vue';
import SectionDonneesFormulaire from '../sections/bareme/SectionDonneesFormulaire.vue';
import SectionResultatBareme from '../sections/bareme/SectionResultatBareme.vue';
import SectionButtons from '../sections/bareme/SectionButtons.vue';
import SectionInfoBaremeH from '../sections/bareme/SectionInfo.vue';

export default {
  name: 'bareme-etape-2',
  components: {
    SectionInfoBaremeH,
    SectionDonneesFormulaire,
    SectionInfoBaremeAjuste,
    SectionResultatBareme,
    SectionButtons,
  },
  mixins: [ProgressBarUtils],
  computed: {
    hasRemarques() {
      return this.dossier.remarques !== null && this.dossier.remarques !== undefined
                && this.dossier.remarques.length > 0 && (this.dossier.remarques[0] !== '' || this.dossier.remarques[1] !== '');
    },
    dossier() {
      return this.$store.getters['dossier/getDossier'];
    },
  },
  methods: {
    onSubmit() {
      this.$router.push({ name: 'routePrelevementEtape1' });
    },
    onGenererPdf() {
      const contribuableIsDto = new ContribuableIsDto();
      contribuableIsDto.frontalier = this.dossier.typeResident.value;
      contribuableIsDto.etatCivil = this.dossier.etatCivil.code;
      contribuableIsDto.enfantaCharge = this.dossier.hasEnfants;
      contribuableIsDto.conjointRevenu = this.dossier.hasConjointRevenu;
      contribuableIsDto.annee = this.dossier.periodeFiscale;
      contribuableIsDto.codeBareme = this.dossier.bareme;
      contribuableIsDto.bareme = this.dossier.bareme;
      contribuableIsDto.nom = this.dossier.nom;
      contribuableIsDto.prenom = this.dossier.prenom;
      contribuableIsDto.noAvs = this.dossier.numeroAVS;
      contribuableIsDto.noMatricule = this.dossier.noCollaborateur;
      contribuableIsDto.isRevenuUnSeulEmployeur = this.dossier.isRevenuUnSeulEmployeur;

      if (this.dossier.remarques.length > 0 && (this.dossier.remarques[0] !== '' || this.dossier.remarques[1] !== '')) {
        contribuableIsDto.communications = this.dossier.remarques;
      }
      contribuableIsDto.adresse = {
        rue: this.dossier.adresseRue,
        localite: this.dossier.adresseLocalite,
      };
      if (this.dossier.isConjointFonctionnaireInt) {
        contribuableIsDto.conjointFonctionnaireInternationale = this.dossier.isConjointFonctionnaireInt;
      }
      if (this.dossier.typeFonctInt) {
        contribuableIsDto.typeFonctionnaireInternational = this.dossier.typeFonctInt.value;
      }
      contribuableIsDto.isEnUnionLibre = this.dossier.isUnionLibre;
      contribuableIsDto.gardeAlternee = this.dossier.isGardeAlternee;
      if (this.dossier.hasEnfants) {
        contribuableIsDto.dateNaissanceEnfants = this.dossier.datesNaissanceEnfants.map(k => k.dateNaissance);
      }
      contribuableIsDto.nbEnfantBaremeH = this.dossier.nbEnfants;
      if (this.dossier.etatCivil.code === 'Marie') {
        contribuableIsDto.conjointRevenuOu = this.dossier.sourceRevenu.map(k => k.code);
      }

      contribuableIsDto.canton = this.dossier.canton ? this.dossier.canton.code : null;
      contribuableIsDto.dateChangementEtatCivil = this.dossier.dateChangementEtatCivil;
      contribuableIsDto.tauxGlobalActivite = this.dossier.tauxGlobalActivite;

      // eslint-disable-next-line
      new ImpotSourceRestApi().getPdf(contribuableIsDto);
    },
  },
  created() {
    if (!this.dossier) {
      this.$router.push({ name: 'routePrelevementEtape1' });
      return;
    }
    this.initProgressBar(2, [this.$t('Bareme.progressBar.etape1'), this.$t('Bareme.progressBar.etape2')], 2, this.$t('Bareme.titre'));
  },
};
</script>

<style scoped>

</style>
